module.exports = __webpack_public_path__ + "img/Rebit_logo.cd1cfc04.svg";